<script lang="ts">
	import { isSideBarOpen } from '../stores';
	import { _ } from 'svelte-i18n';
	import { getHubStores } from '$lib/stores/hubStores';
	import { logicalPropTransition } from '$lib/transistions/LogicalPropTransition';
	import SideBarItem from '$lib/components/CollectionsNav/SideBar/SideBarItem.svelte';
	import { clickOutside } from '$lib/actions/clickOutside';
	import Icon from '$lib/components/Icon/Icon.svelte';

	const { collections } = getHubStores();

	const closeSideBar = () => {
		$isSideBarOpen = false;
	};
</script>

{#if $isSideBarOpen}
	<aside
		transition:logicalPropTransition|global={{ direction: 'inline' }}
		use:clickOutside={closeSideBar}
	>
		<div id="header">
			<h2>{$_('common.collections')}</h2>
			<button type="button" on:click={closeSideBar}
				><Icon clickable icon="close" size="24" /></button
			>
		</div>
		<ul class="scroll">
			{#each $collections as collection}
				<SideBarItem {collection} />
			{/each}
		</ul>
	</aside>
{/if}

<style>
	aside {
		position: fixed;
		z-index: 900;
		inline-size: 300px;
		background-color: white;
		inset-block: 0;
		inset-inline-end: 0;
	}

	ul {
		max-block-size: calc(100vh - 50px);
	}

	#header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-inline: var(--gutterMedium);
		border-block-end: 1px solid rgb(238 238 238);
	}

	button {
		visibility: hidden;
		padding: 0;
		border-width: 0;
		background-color: transparent;
	}

	h2 {
		margin-block: 0;
		color: rgb(33 42 51);
		line-height: 45px;
	}

	@media screen and (max-width: 575px) {
		aside {
			inline-size: 100%;
		}

		button {
			visibility: visible;
		}
	}
</style>
